import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  useProductPrice,
  isAuthenticated,
} from "@ten24/slatwall-storefront-react-private/global";
import { DraftCartQuotes } from "../DraftCartQuotes/DraftCartQuotes";
import { ProductQuantityInput } from "./ProductQuantityInput";
import { Link } from "react-router-dom";
import React from "react";

const ProductForm = ({
  sku,
  isDisabled,
  isLoading,
  quantity,
  setQuantity,
  config,
}) => {
  //changes - getting config as a param
  const { t } = useTranslation();
  const { showAddToCart } = useProductPrice({
    salePrice: sku?.salePrice,
    listPrice: sku?.listPrice,
  });
  const selectedCartOrQuote = useSelector((state) => state.cartQuoteReducer);
  const siteSetting = useSelector((state) => state.configuration.site.settings);
  const authenticationRequiredForAddToCart = !!sku?.settings
    ?.skuRequireLoginToAddToCart
    ? !isAuthenticated()
    : false;

  // if (toBoolean(sku?.settings?.skuAllowOrderTemplateFlag)) return null
  return (
    <div className="d-flex d-flex align-items-end ">
      <form
        className="row align-items-end w-100"
        onSubmit={(event) => {
          event.preventDefault();
        }}>
        {showAddToCart &&
          !authenticationRequiredForAddToCart &&
          siteSetting.sitePurpose !== "Non-Transactional" && (
            <>
              <div className="col-12 form-group me-2 row align-items-center">
                {/* changes - using config to validat the display of input field */}
                <ProductQuantityInput
                  setQuantity={setQuantity}
                  quantity={quantity}
                  sku={sku}
                  stock={sku.calculatedQATS || sku.stocks_calculatedQATS}
                  config={config}
                />
              </div>
              <div
                className="accordion accordion-cart col-12"
                id="accordioncartExample">
                <DraftCartQuotes
                  selectedCartOrQuote={selectedCartOrQuote}
                  sku={sku}
                  quantity={quantity}
                  isDisabled={isDisabled}
                  isLoading={isLoading}
                />
              </div>
            </>
          )}
        {showAddToCart &&
          authenticationRequiredForAddToCart &&
          siteSetting.sitePurpose !== "Non-Transactional" && (
            <div className="alert alert-warning fs-6" role="alert">
              {t("frontend.product.loginToAdd")}
              <br />
              <Link to="/my-account/login">
                {" "}
                {t("frontend.account.login")}{" "}
              </Link>
            </div>
          )}
      </form>
    </div>
  );
};

export { ProductForm };
